import React from "react";
import { feature } from "lib/featureFlags";

type Props = React.PropsWithChildren<{
    featureName: string;
}>;
const FeatureFlag = ({ featureName, children }: Props) => {
    if (!feature(featureName, false)) {
        return null;
    }
    return children;
};
export default FeatureFlag;
